import React, { type ReactNode, createContext, useContext } from 'react'

const GivePriorityToGedcomAlertContext = createContext<boolean>(false)

export function useGivePriorityToGedcomAlert(): boolean {
  return useContext(GivePriorityToGedcomAlertContext)
}

type Props = { children: ReactNode; givePriorityToGedcomAlert: boolean }

export default function GivePriorityToGedcomAlertProvider({ children, givePriorityToGedcomAlert }: Props): JSX.Element {
  return (
    <GivePriorityToGedcomAlertContext.Provider value={givePriorityToGedcomAlert}>
      {children}
    </GivePriorityToGedcomAlertContext.Provider>
  )
}
